import request from '@/utils/request';

export function list(params) {
  return request({
    url: '/unijobs/users',
    method: 'get',
    params
  });
}